export default {
      id: "message_center-usage",
      viewBox: "0 0 266.64 304.14",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#message_center-usage",
      toString: function () {
        return this.url;
      }
    }